// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2FVWa","signatureButtonsRight":"ModalSign_signatureButtonsRight__2zBpp"};